var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.0932617 26.4497L0.162315 8.51056C0.187426 2.04449 6.48177 -1.99129 11.5373 1.21735L25.5657 10.1207L50.7849 26.4497L25.5657 42.7787L11.5373 51.682C6.48177 54.8906 0.187426 50.8572 0.162315 44.3911L0.0932617 26.4497Z",
    fill: "#05FF76"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M89.9999 26.4496L89.9393 42.1699C89.91 49.6257 82.651 54.2796 76.8191 50.5807L64.5275 42.7786L39.3083 26.4496L64.5275 10.1207L76.8191 2.31862C82.6489 -1.38259 89.91 3.27122 89.9393 10.7294L89.9999 26.4496Z",
    fill: "#05FF76"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0467 63.98C48.7148 63.98 51.6884 60.6783 51.6884 56.6055C51.6884 52.5326 48.7148 49.231 45.0467 49.231C41.3786 49.231 38.405 52.5326 38.405 56.6055C38.405 60.6783 41.3786 63.98 45.0467 63.98Z",
    fill: "#05FF76"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0467 90.0067C48.7148 90.0067 51.6884 86.7051 51.6884 82.6322C51.6884 78.5594 48.7148 75.2577 45.0467 75.2577C41.3786 75.2577 38.405 78.5594 38.405 82.6322C38.405 86.7051 41.3786 90.0067 45.0467 90.0067Z",
    fill: "#05FF76"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.71a523f94c25363a0b667634ef879860.svg";
export { ForwardRef as ReactComponent };